import Specialist from '../model/Specialist';
// Only use for PHN
export const swapSpecialistOrder = (array: Specialist[], id1: string, id2: string) => {
  const newArr = [...array];

  const index1 = newArr.findIndex((element) => element.id === id1);
  const index2 = newArr.findIndex((element) => element.id === id2);

  if (index1 === -1 || index2 === -1) {
    return [...array];
  }

  [newArr[index1], newArr[index2]] = [newArr[index2], newArr[index1]];

  return newArr;
};
